import { policyProps } from '../context';
import { routeConfig } from '../config';
interface PolicyProps extends policyProps {
    Policies?: Array<policyProps>;
}


const BaseHomeRoute = routeConfig.baseHomeUrl + '/policies/prispek';
const BaseBenefitsRoute = BaseHomeRoute + '/benefits';
const BaseHealthRoute = BaseHomeRoute + '/health&safety';
const BasePopiaRoute = BaseHomeRoute + '/popia';

export const PrispekPolicies: Array<PolicyProps> = [
    {
        Name: 'Individual Policies',
        Variant: 'folder',
        Policies: [
            {
                Name: 'Access Control',
                Reference: `${BaseHomeRoute}/Access_Control.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Alcohol and Drugs',
                Reference: `${BaseHomeRoute}/Alcohol_&_Drug.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Bullying',
                Reference: `${BaseHomeRoute}/Bullying.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Company Property',
                Reference: `${BaseHomeRoute}/Company_Property.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Computer Email',
                Reference: `${BaseHomeRoute}/Computer_Email.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Corporate Compliance',
                Reference: `${BaseHomeRoute}/Corporate_Compliance.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Counselling Procedure',
                Reference: `${BaseHomeRoute}/Counselling.pdf`,
                Variant: 'item'
            },
            {
                Name: 'COVID Workplace',
                Reference: `${BaseHomeRoute}/COVID.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Electronic Data Cyber Security',
                Reference: `${BaseHomeRoute}/Cyber_Security.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Disaster Recovery Plan',
                Reference: `${BaseHomeRoute}/Disaster_Recovery.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Disclosure Of Confidential Information',
                Reference: `${BaseHomeRoute}/Disclosure_Of_Confidential_Information.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Discrimination Harrassment',
                Reference: `${BaseHomeRoute}/Discrimination_Harrassment.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Dispute Settlement Procedure',
                Reference: `${BaseHomeRoute}/Dispute_Settlement.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Presentation and Dress Code',
                Reference: `${BaseHomeRoute}/Dress_Code.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Employee Movements',
                Reference: `${BaseHomeRoute}/Employee_Movements.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Working Hours',
                Reference: `${BaseHomeRoute}/Hours.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Leave',
                Reference: `${BaseHomeRoute}/Leave_Policy.pdf`,
                Variant: 'item'
            },
            {
                Name: 'No Smoking',
                Reference: `${BaseHomeRoute}/No_Smoking.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Office Refreshments',
                Reference: `${BaseHomeRoute}/Office_Refreshments.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Parking',
                Reference: `${BaseHomeRoute}/Parking.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Remuneration',
                Reference: `${BaseHomeRoute}/Remuneration.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Social Media Guidelines',
                Reference: `${BaseHomeRoute}/Social_Media.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Telephone',
                Reference: `${BaseHomeRoute}/Telephone.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Travel',
                Reference: `${BaseHomeRoute}/Travel.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Website Privacy Policy',
                Reference: `${BaseHomeRoute}/Website_Privacy_Policy.pdf`,
                Variant: 'item'
            },
            {
                Name: 'Website Terms and Conditions',
                Reference: `${BaseHomeRoute}/Website_TC.pdf`,
                Variant: 'item'
            }
        ]
    },
    {
        Name: 'Group Benefits',
        Variant: 'folder',
        Policies: [
            {
                Name: 'Benefits',
                Variant: 'item',
                Reference: `${BaseBenefitsRoute}/Benefits.pdf`
            },
            {
                Name: 'Capital Alliance Terms & Conditions',
                Variant: 'item',
                Reference: `${BaseBenefitsRoute}/Capital_Alliance.pdf`
            },
            {
                Name: 'Disability Income Benefits',
                Variant: 'item',
                Reference: `${BaseBenefitsRoute}/Disability_Income.pdf`
            },
            {
                Name: 'Funeral Cover',
                Variant: 'item',
                Reference: `${BaseBenefitsRoute}/Funeral_Cover.pdf`
            },
            {
                Name: 'Group Benefits',
                Variant: 'item',
                Reference: `${BaseBenefitsRoute}/Group_Benefits.pdf`
            },
            {
                Name: 'Group Life Cover',
                Variant: 'item',
                Reference: `${BaseBenefitsRoute}/Group_Life_Cover.pdf`
            },
            {
                Name: 'Hollard Terms & Conditions',
                Variant: 'item',
                Reference: `${BaseBenefitsRoute}/Hollard_Terms_&_Conditions.pdf`
            },
            {
                Name: 'Trauma Cover',
                Variant: 'item',
                Reference: `${BaseBenefitsRoute}/Trauma_Cover.pdf`
            },
            {
                Name: 'TSA Beneficiary Nomination Form',
                Variant: 'item',
                Reference: `${BaseBenefitsRoute}/TSA_Nomination.pdf`
            }
        ]
    },
    {
        Name: 'Health and Safety',
        Variant: 'folder',
        Policies: [
            {
                Name: 'Evacuation Plan',
                Variant: 'item',
                Reference: `${BaseHealthRoute}/Evacuation_Plan.pdf`
            },
            {
                Name: 'Evacuation Procedures',
                Variant: 'item',
                Reference: `${BaseHealthRoute}/Evacuation_Procedures.pdf`
            },
            {
                Name: 'First Aid Checklist',
                Variant: 'item',
                Reference: `${BaseHealthRoute}/First_Aid_Checklist.pdf`
            },
            {
                Name: 'Hazard Report Form',
                Variant: 'item',
                Reference: `${BaseHealthRoute}/Hazard_Form.pdf`
            },
            {
                Name: 'Incedent Report',
                Variant: 'item',
                Reference: `${BaseHealthRoute}/Incedent_Report.pdf`
            },
            {
                Name: 'OHS Policy',
                Variant: 'item',
                Reference: `${BaseHealthRoute}/OHS_Policy.pdf`
            },
            {
                Name: 'OHS Policy Statement',
                Variant: 'item',
                Reference: `${BaseHealthRoute}/OHS_Statement.pdf`
            }
        ]
    },
    {
        Name: 'POPIA',
        Variant: 'folder',
        Policies: [
            {
                Name: 'Complaint Form',
                Variant: 'item',
                Reference: `${BasePopiaRoute}/Complaint_Form.pdf`
            },
            {
                Name: 'POPIA Privacy Notice',
                Variant: 'item',
                Reference: `${BasePopiaRoute}/Privacy_Notice.pdf`
            }
        ]
    }
];
